<template>
    <b-container>
        <b-row v-if="card">
            <b-col cols="12" md="4">
                <b-row class="py-2">
                    <b-col cols="12" class="text-center">
                        <h5>{{$t('prepaid.group.actions')}}</h5>
                    </b-col>
                </b-row>
                <b-row class="py-2 flex-center">
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.editCard class="float-right w-100"><span class="fa fa-edit mx-2"></span> {{$t('prepaid.group.buttons.editCard')}}</b-btn>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.deleteCard @click="" variant="danger" class="float-right w-100"><span class="fa fa-print mx-2"></span> {{$t('prepaid.group.buttons.deleteCard')}}</b-btn>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="8" class="eventDash p-2">
                <h5 class="text-center"> {{ card.full_name }} </h5>
                <h6 class="mx-2">{{$t('prepaid.group.card.modal.generate.desc')}}: {{card.desc}}</h6>
                <h6 class="mx-2">{{$t('prepaid.group.card.modal.generate.dob')}}: {{card.dob | moment('DD.MM.YYYY')}}</h6>
                <h6 class="mx-2">{{$t('prepaid.group.card.modal.generate.num')}}: {{card.phone}}</h6>
                <h6 class="mx-2">{{$t('prepaid.group.card.modal.generate.sector')}}: <span v-for="sector in sectors" v-if="sector.id===card.pref_sector_id">{{sector.code}}</span> - {{$t('prepaid.group.card.modal.generate.row')}}: {{card.pref_row}} - Seat: {{card.pref_seat}}</h6>
            </b-col>
        </b-row>


        <b-modal centered
                 no-close-on-backdrop
                 id="editCard"
                 title="Edit current card"
                 hide-footer>
                  <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.edit.card')}}
                </template>
            <b-form @submit.prevent="editCard()" data-vv-scope="editCard">

                <b-row>

                    <b-col cols="6" class="flex-center">
                        <h5>{{ group.name }}</h5>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="prepaidGroup">{{$t('prepaid.title')}}
                            <b-form-input :state="validateState('editCard.prepaidGroup')"
                                          :class="{'is-invalid': veeErrors.has('editCard.prepaidGroup')}"
                                          v-validate="'required|min_value:1'" v-model="group.id"
                                          id="prepaidGroup" ref="prepaidGroup" type="number" size="md" name="prepaidGroup" disabled></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.prepaidGroup') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="fullName">{{$t('prepaid.group.card.modal.generate.name')}}
                            <b-form-input :state="validateState('editCard.fullName')"
                                          :class="{'is-invalid': veeErrors.has('editCard.fullName')}"
                                          v-model="card.full_name" v-validate="'required|min:6'" id="fullName" ref="fullName" type="text" size="md" name="fullName"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.fullName') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="dob">{{$t('prepaid.group.card.modal.generate.dob')}}
                            <date-picker format="YYYY-MM-DD HH:mm:ss"
                                         name="dob"
                                         v-validate="'required'"
                                         v-model="card.dob"
                                         :not-after="new Date()"
                                         :lang="$parent[$i18n.locale]"
                                         type="datetime"
                                         :minute-step="10"
                                         :first-day-of-week="1"
                                         class="w-100"
                                         id="dob">
                            </date-picker>
                            <span class="vvError">{{ veeErrors.first('editCard.dob') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="description">{{$t('prepaid.group.card.modal.generate.desc')}}
                            <b-form-input :state="validateState('editCard.description')"
                                          :class="{'is-invalid': veeErrors.has('editCard.description')}"
                                          v-model="card.desc" v-validate="'required|min:6'" id="description" ref="description" type="text" size="md" name="description"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.description') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="phone">{{$t('prepaid.group.card.modal.generate.num')}}
                            <b-form-input :state="validateState('editCard.phone')"
                                          :class="{'is-invalid': veeErrors.has('editCard.phone')}"
                                          v-model="card.phone" v-validate="'required|min:6'" id="phone" ref="phone" type="text" size="md" name="phone"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.phone') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="cardCode">{{$t('prepaid.group.card.modal.generate.code')}}
                            <b-form-input :state="validateState('editCard.cardCode')"
                                          :class="{'is-invalid': veeErrors.has('editCard.cardCode')}"
                                          v-model="card.code" v-validate="'required|alpha_num'" id="cardCode" ref="cardCode" type="text" size="md" name="cardCode"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.cardCode') }}</span>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label-for="cardCode2">{{$t('prepaid.group.card.modal.generate.code2')}}
                            <b-form-input :state="validateState('editCard.cardCode2')"
                                          :class="{'is-invalid': veeErrors.has('editCard.cardCode2')}"
                                          v-model="card.code2" v-validate="'required|alpha_num'" id="cardCode2" ref="cardCode2" type="text" size="md" name="cardCode2"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.cardCode2') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="4">
                    <b-form-group label-for="prefSector">{{$t('prepaid.group.card.modal.generate.sector')}}
                        <b-form-select v-model="card.pref_sector_id" name="prefSector" v-validate="'required|alpha_num'">
                            <option v-for="sector in sectors" :value="sector.id">{{sector.code}}</option>
                        </b-form-select>
                        <span class="vvError">{{ veeErrors.first('editCard.prefSector') }}</span>
                    </b-form-group>
                </b-col>

                    <b-col cols="4">
                        <b-form-group label-for="prefRow"
                                      v-for="sector in sectors"  v-if="sector.id === card.pref_sector_id">{{$t('prepaid.group.card.modal.generate.row')}}
                            <b-form-input :state="validateState('editCard.prefRow')"
                                          :class="{'is-invalid': veeErrors.has('editCard.prefRow')}"
                                          v-model.number="card.pref_row" v-validate="'required|min_value:1|max_value:'+sector.rows" id="prefRow" ref="prefRow" type="number" size="md" name="prefRow"></b-form-input>
                            <b-form-text id="row-help-block" v-for="sector in sectors" v-if="sector.id === card.pref_sector_id">
                                {{$t('prepaid.group.card.modal.generate.of')}} {{ sector.rows }}
                            </b-form-text>
                            <span class="vvError">{{ veeErrors.first('editCard.prefRow') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="4">
                        <b-form-group label-for="prefSeat"
                                      v-for="sector in sectors"  v-if="sector.id === card.pref_sector_id">{{$t('prepaid.group.card.modal.generate.seat')}}
                            <b-form-input :state="validateState('editCard.prefSeat')"
                                          :class="{'is-invalid': veeErrors.has('editCard.prefSeat')}"
                                          v-model.number="card.pref_seat" v-validate="'required|min_value:1|max_value:'+sector.row_seats" id="prefSeat" ref="prefSeat" type="number" size="md" name="prefSeat"></b-form-input>
                            <b-form-text id="seat-help-block" v-for="sector in sectors" v-if="sector.id === card.pref_sector_id">
                                {{$t('prepaid.group.card.modal.generate.of')}} {{ sector.row_seats }}
                            </b-form-text>
                            <span class="vvError">{{ veeErrors.first('editCard.prefSeat') }}</span>
                        </b-form-group>
                    </b-col>



                </b-row>

                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-btn type="submit" :disabled="veeErrors.any('editCard')" ref="btnEdit" variant="primary" class="w-50">{{$t('prepaid.group.card.modal.edit.button')}}</b-btn>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal centered
                 id="deleteCard"
                 title="Confirmation"
                 @ok="deleteCard"
                 ok-variant="danger">
                   <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.delTitle')}}
                </template>
            <p class="my-4">{{$t('prepaid.group.card.modal.delete')}}</p>
        </b-modal>


    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'prepaidCard',
        data() {
            return {
                group: {},
                card: {},
                sectors: null,
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            editCard(){
                this.$axios.post('prepaid/updateByCardId',{
                    params: {
                        id: this.card.prepaid_group_id,
                        card: this.card
                    }
                }).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$root.$emit('bv::hide::modal', 'editCard', '#btnEdit');
                    }else{
                        this.$toasted.global.err({
                            message : this.$t(response.data.data.msg)
                        });
                    }
                });
            },
            deleteCard(){
                this.$axios.post('prepaid/deleteByCardId',{
                        params: {
                            id: this.card.prepaid_group_id,
                            card: this.card
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$router.push('/prepaid/' + this.card.prepaid_group_id)
                    }
                });
            },
            getGroup(){
                this.$axios.get('/prepaid/getById',
                    {
                        params: {
                            id: this.card.prepaid_group_id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.group = response.data.data;
                    }
                });
            },

            getSectors(){
                this.$axios.get('sectors').then(response => {
                    if (response.status === 200) {
                        this.sectors = response.data.data;
                    }
                })
            },
        },

        created() {
            this.$axios.get('/prepaid/getByCardId',
                {
                    params: {
                        id: this.$route.params.id,
                    }
                }
            ).then(response => {
                if (response.status === 200) {
                    this.card = response.data.data;
                }
            });
            this.getGroup();
            this.getSectors();
            let self = this;
            this.interval = setInterval(function () {
                self.getGroup();
                self.getSectors();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>